import React from 'react';

const AboutPage = () => {
  return <>AboutPage</>;
};

export default AboutPage;
